import { normalize } from "@/utils/strings"

/**
 * Checks if all words from the query appear in any of the given fields, in any order
 * @param {string} query - Search text
 * @param {...string} fields - Fields to search through
 * @returns {boolean} True if every query word is found (empty query matches everything)
 * @example
 * matchesWords('spac test', 'testujemy spacje') => true
 */
const matchesWords = (query, ...fields) => {
  const words = normalize(query ?? '').split(/\s+/).filter(Boolean)
  if (!words.length) return true

  const haystack = fields.map(field => normalize(field ?? '')).join(' ')

  return words.every(word => haystack.includes(word))
}

// Filter items in selects/autocompletes with diacritic chars eg. ą ę ś ć ...
const filterByName = (itemTitle, queryText, item) => matchesWords(queryText, item.raw.name)

export { filterByName, matchesWords }
